module.exports = __webpack_public_path__ + "img/text_shine.45dea445.png";